import { Pipe, PipeTransform } from '@angular/core';
import { formatSadmEntityType, SadmEntity, SadmType } from '@pixacare/domain';
import { capitalize } from '@pixacare/shared';

@Pipe({
  name: 'sadmEntityType',
  pure: true,
})
export class SadmEntityTypePipe implements PipeTransform {
  transform(value: Pick<SadmEntity, 'name' | 'patientEntityIndex'>, sadmType?: SadmType, index?: number): string {
    return capitalize(formatSadmEntityType(value as SadmEntity, sadmType, index));
  }
}
